module.exports = "<nm-header *ngIf=\"data.user.isLoggedIn\"></nm-header>\n\n<div id=\"main-container\" class=\"main-container\">\n\n\t<nm-sidebar *ngIf=\"data.user.isLoggedIn\"></nm-sidebar>\n\n\t<div class=\"main-content\">\n\t\t<div class=\"main-content-inner\">\n\t\t\t<nm-breadcrumbs *ngIf=\"data.user.isLoggedIn\"></nm-breadcrumbs>\n\t\t\t\n\t\t\t<div class=\"page-content\">\n\t\t\t\t<router-outlet></router-outlet>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<nm-footer *ngIf=\"data.user.isLoggedIn\"></nm-footer>\n\t<nm-scroll-up *ngIf=\"data.user.isLoggedIn\"></nm-scroll-up>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 499
// module chunks = 0